import getWithToken from './base/get-with-token'

const getTaxonomyBenchmarkSewerChartData = (id, query) => getWithToken(`/customer-taxonomy/${id}/benchmark-sewer-data`)(query)

export default getTaxonomyBenchmarkSewerChartData
